import { EditorPrebuiltModule } from '@dev/template-editor';
import { useMainFeatureWithCTA } from './MainFeatureWithCTA';
import { useFeaturesTwoColumns } from './FeaturesTwoColumns';
import { useFeaturesThreeColumns } from './FeaturesThreeColumns';
import { useFeatureLeftAlignedImage } from './FeatureLeftAlignedImage';
import { useFeatureRightAlignedImage } from './FeatureRightAlignedImage';
import { useBasicBlockOneColumn } from './BasicBlockOneColumn';
import { useBasicBlockTwoColumns } from './BasicBlockTwoColumns';
import { useBasicBlockThreeColumns } from './BasicBlockThreeColumns';
import { useGalleryTwoColumns } from './GalleryTwoColumns';
import { useGalleryThreeColumns } from './GalleryThreeColumns';
import { useCallsToActionTwoColumns } from './CallsToActionTwoColumns';
import { useCallsToActionThreeColumns } from './CallsToActionThreeColumns';

export const usePrebuiltModulesList = (): EditorPrebuiltModule[] => [
    useMainFeatureWithCTA(),
    useFeaturesTwoColumns(),
    useFeaturesThreeColumns(),
    useFeatureLeftAlignedImage(),
    useFeatureRightAlignedImage(),
    useBasicBlockOneColumn(),
    useBasicBlockTwoColumns(),
    useBasicBlockThreeColumns(),
    useGalleryTwoColumns(),
    useGalleryThreeColumns(),
    useCallsToActionTwoColumns(),
    useCallsToActionThreeColumns(),
];
